import { Component } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'

import CollectionList from '../../Collection/CollectionList'
import CollectionItem from '../../Collection/CollectionItem'
import { getAssetLink } from '../../../helpers/get-asset-link'
import { selectBuildings } from '../../../reducers/buildingSelectorReducer'

const isPmsConnected = (building) =>
  Boolean(
    building.entrataManagementId ||
      building.realPageManagementId ||
      building.yardiManagementId ||
      building.rentManagerManagementId ||
      building.resmanManagementId,
  )

class OrganisationPlacesList extends Component {
  static propTypes = {
    buildings: PropTypes.array.isRequired,
    searchQuery: PropTypes.string,
    params: PropTypes.object,
  }

  render() {
    const { searchQuery, params } = this.props
    const { buildings } = this.props
    const selectedBuildingId = Number(params?.buildingId)
    let filteredBuildings = [...buildings]

    if (typeof searchQuery !== 'undefined' && searchQuery !== '') {
      filteredBuildings = filteredBuildings.filter((building) => {
        return (
          building.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
          building.address.toLowerCase().includes(searchQuery.toLowerCase())
        )
      })
    }

    return (
      <CollectionList>
        {typeof filteredBuildings !== 'undefined' &&
          filteredBuildings.map((building) => {
            return (
              <Link key={building.id} to={`/dashboard/organisation/places/legacy/${building.id}`}>
                <CollectionItem
                  rounded
                  mark
                  isHighlight={building.id === selectedBuildingId}
                  additionalClass={isPmsConnected(building) ? 'ctp-collection-item--pms' : ''}
                >
                  <img
                    src={getAssetLink({ path: 'chitown-building', file: building.logo })}
                    alt={''}
                    style={{ width: '60px', height: '35px' }}
                  />
                  <strong>{building.name}</strong>
                  <span>{building.address}</span>
                </CollectionItem>
              </Link>
            )
          })}
      </CollectionList>
    )
  }
}

export default connect((state) => ({
  buildings: selectBuildings(state),
}))(OrganisationPlacesList)
